import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Loader2 } from 'lucide-react';
import styles from './button.scss';

export const BUTTON_VARIANTS = ['primary', 'outline', 'destructive'];
export const BUTTON_SIZES = ['large', 'compact'];

const Button = React.forwardRef(function Button(
  {
    children,
    className,
    variant = 'primary',
    size = 'large',
    type = 'button',
    startIcon,
    endIcon,
    loading = false,
    disabled = false,
    onClick,
    ...rest
  },
  ref
) {
  return (
    <button
      ref={ref}
      className={classNames(
        styles.button,
        styles[variant],
        styles[size],
        loading && styles.loading,
        className
      )}
      type={type}
      disabled={disabled || loading}
      aria-busy={loading ? 'true' : undefined}
      onClick={onClick}
      {...rest}
    >
      {loading ? (
        <span className={styles.icon} aria-hidden="true">
          <Loader2 className={styles.spinner} />
        </span>
      ) : (
        startIcon && (
          <span className={styles.icon} aria-hidden="true">
            {startIcon}
          </span>
        )
      )}
      {children}
      {endIcon && (
        <span className={styles.icon} aria-hidden="true">
          {endIcon}
        </span>
      )}
    </button>
  );
});

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  variant: PropTypes.oneOf(BUTTON_VARIANTS),
  size: PropTypes.oneOf(BUTTON_SIZES),
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Button;
